import React, { useEffect } from "react";
import { useDragLayer } from "react-dnd";
import HalfCard from "./HalfCard";

const CustomDragLayer = () => {

    const { isDragging, item, clientOffset } = useDragLayer((monitor) => ({
      isDragging: monitor.isDragging(),
      item: monitor.getItem(),
      clientOffset: monitor.getClientOffset(),
    }));

    useEffect(() => {
        // document.body.style.overflow = isDragging ? 'hidden' : '';
        isDragging ? document.body.classList.add('dragging') : document.body.classList.remove('dragging');
    }, [isDragging])


    if (!isDragging || !item || !clientOffset) return null;

    // Adjust position for scroll offset
    const adjustedX = clientOffset.x + window.scrollX;
    const adjustedY = clientOffset.y + window.scrollY;

    return (
      <>
        <div
          style={{
            position: "absolute",
            pointerEvents: "none",
            boxShadow: "none",
            left: adjustedX,
            top: adjustedY,
            transform: "translate(-50%, -50%)",
          }}
        >
          <div className="drag-layer cards-in-hand">
          <HalfCard card={item.card} cardStyle={{opacity: 0.8}} isShowType={true} />
          </div>
        </div>
      </>

    );
  };

  export default CustomDragLayer;


// import { useDragLayer } from "react-dnd";
// import HalfCard from "./HalfCard";

// const CustomDragLayer = () => {

//   const { isDragging, item, clientOffset } = useDragLayer((monitor) => ({
//     isDragging: monitor.isDragging(),
//     item: monitor.getItem(),
//     clientOffset: monitor.getClientOffset(),
//   }));

//   if (!isDragging || !item || !clientOffset) {
//     return null;
//   }

//   const adjustedX = clientOffset.x + window.scrollX;
//   const adjustedY = clientOffset.y + window.scrollY;

//   return (
//     <>
//       <div
//         style={{
//           position: "absolute",
//           pointerEvents: "none",
//           boxShadow: "none",
//           left: adjustedX,
//           top: adjustedY,
//           transform: "translate(-50%, -20%)",
//         }}
//       >
//         <div className="drag-layer cards-in-hand">
//           <HalfCard card={item.card} cardStyle={{ opacity: 0.8 }} isShowType={true} />
//         </div>
//       </div>
//     </>

//   );
// };

// export default CustomDragLayer;

